import NachWrapper from 'features/nach/components/NachWrapper';
import { Button, Spin } from 'antd';
import Form from 'antd/lib/form';
import { useNavigate } from 'react-router-dom';
import {
  getNachMandateDetailsResponseData,
  nachBankDetailType,
  setUpAutoPay,
  // validateUpi,
} from 'api/nach';
import { customer_routes } from '../routes';
//import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';
import BankDetails from './BankDetails';

// type VPAFormType = {
//   vpa: string;
// };
interface Props {
  mandateId: string;
  ifscCode?: string;
  accountNumber?: string;
  mandateLinkData: getNachMandateDetailsResponseData;
  bankData: nachBankDetailType;
}

function AutoPay({ mandateId, ifscCode, accountNumber, bankData }: Props) {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  // const [isValidVpa, setIsValidVpa] = useState(false);
  const [bankCode, setBankCode] = useState<string | undefined>(undefined);
  // const [vpaInput, setVpaInput] = useState('');
  const [branchName, setBranchName] = useState('');
  //const values = form.getFieldsValue();
  //const isFormIncomplete = !values.ifsc || !values.accountNumber || !values.accountHolderName;

  // 🔄 FIX: Watch the fields dynamically so isFormIncomplete updates on every keystroke
  const formValues = Form.useWatch([], form);
  const isFormIncomplete =
    !formValues?.ifsc ||
    !formValues?.accountNumber ||
    !formValues?.accountHolderName;

  // console.log('Madate Link Data  in autoPay', mandateLinkData);
  console.log(bankData);
  console.log(branchName);
  console.log(bankCode);
  console.log(ifscCode);
  console.log(accountNumber);


  const handleSetBankCode = (value: string) => {
    setBankCode(value);
  };
  const handleBranchName = (value: string) => {
    setBranchName(value);
  };

  // const initiatePaymentHandler = () => {
  //   console.log('initiate paymenth');
  //   // 🛑 CRITICAL FIX: Explicitly validate form fields here. 
  //   // If "accountHolderName" or any required field is blank, 
  //   // it triggers UI warnings and breaks the execution chain immediately.
  //   form.validateFields()
  //     .then((values) => {
  //       // Extra fallback safety check
  //       if (!values.accountHolderName || !values.ifsc || !values.accountNumber) {
  //         console.warn("Validation passed but crucial fields are empty. Holding redirect process.");
  //         return;
  //       }

  //       setUpAutoPay({
  //         mandateId: mandateId as any,
  //         amount: 1,
  //         //vpa: vpaInput,
  //         type: 'ACCOUNT',
  //         ifsc: form.getFieldValue('ifsc'),
  //         accountNumber: form.getFieldValue('accountNumber'),
  //         maxBillAMount: 15000,
  //       }).then((res) => {
  //         console.log('res autopay', res);

  //         if (res.status === 'SUCCESS' && res.data) {
  //           // ✅ CRITICAL FRONTEND FIX: 
  //           // If PhonePe returned an intent link, push the user's browser to it
  //           if (res.data.redirectUrl) {
  //             console.log('Redirecting customer directly to PhonePe secure gateway matrix...');
  //             window.location.href = res.data.redirectUrl;
  //           } else {
  //             // Fallback to internal page routing if no redirect link was provided
  //             console.warn('API succeeded but no redirectUrl was found.');
  //             navigate(customer_routes.AutoPay.to, {
  //               state: { merchantOrderId: res.data.merchantOrderId, mandateId: mandateId },
  //               replace: true,
  //             });
  //           }
  //         } else {
  //           alert(res.message || "Failed to initialize the mandate transaction.");
  //         }
  //       }).catch((err) => {
  //         console.error("Network or systemic error during mandate setup application processing:", err);
  //         alert("An unexpected network error occurred. Please try again.");
  //       });
  //     };

  const initiatePaymentHandler = () => {
    console.log('initiate paymenth');

    // 1. Explicitly validate form fields
    form.validateFields()
      .then((values) => {
        // Extra fallback safety check
        if (!values.accountHolderName || !values.ifsc || !values.accountNumber) {
          console.warn("Validation passed but crucial fields are empty. Holding redirect process.");
          return;
        }

        setUpAutoPay({
          mandateId: mandateId as any,
          amount: 1,
          type: 'ACCOUNT',
          ifsc: form.getFieldValue('ifsc'),
          accountNumber: form.getFieldValue('accountNumber'),
          maxBillAMount: 15000,
          accountHolderName: form.getFieldValue('accountHolderName'),
          bankName: form.getFieldValue('bankName') || bankData?.bankName,
          branchName: form.getFieldValue('branchName') || branchName,
          bankCode: bankCode,


        }).then((res) => {
          console.log('res autopay', res);


          if (res.status === 'SUCCESS' && res.data) {
            if (res.data.redirectUrl) {
              console.log('Redirecting customer directly to PhonePe secure gateway matrix...');
              window.location.href = res.data.redirectUrl;
            } else {
              console.warn('API succeeded but no redirectUrl was found.');
              navigate(customer_routes.AutoPay.to, {
                state: { merchantOrderId: res.data.merchantOrderId, mandateId: mandateId },
                replace: true,
              });
            }
          } else {
            alert(res.message || "Failed to initialize the mandate transaction.");
          }
        }).catch((err) => {
          console.error("Network or systemic error during mandate setup application processing:", err);
          alert("An unexpected network error occurred. Please try again.");
        });
      }) // 🔐 Closes the .then() block
      .catch((errorInfo) => {
        // 🛑 Captures validation failures, showing UI errors and holding the redirect process
        console.log('Form validation failed, holding redirection:', errorInfo);
      }); // 🔐 Closes the validateFields block
  }; // 🔐 Closes the initiatePaymentHandler function


  return (
    <div style={{ marginTop: '60px' }}>
      <NachWrapper title="Auto Pay">
        <Spin spinning={false}>

          <div className="standard-forms">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                marginTop: '30px',
              }}
            >
              <BankDetails
                nachId={1}
                nachBankData={bankData}
                form={form}
                setEnachBankCode={handleSetBankCode}
                setBranckName={handleBranchName}
                sourceType="AutoPay" // <--- Add this line
              />

              <div className="row" style={{ width: '100%' }}>


                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={initiatePaymentHandler}
                    disabled={isFormIncomplete}
                    style={{ marginTop: '20px', maxWidth: '150px' }}
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {/* </Form> */}
        </Spin>
      </NachWrapper>
    </div>
  );
}

export default AutoPay;
